// =============================================================================
//  ID連携用 最初に呼ぶ関数
// =============================================================================
function PG_idcon(shop_permanent_domain) {

  var rstr = /code=/;
  var openid_complete = /token=/;
  var error = /error_status=/;
  var r2str = /token=/;

  if(PG_no_fetch()) return;

  //////////////////////////////////////////////////////////////////////////////
  // codeがあった場合
  //////////////////////////////////////////////////////////////////////////////
  if(window.location.href.match(rstr)) {

    // code 取得 ---
    var ar = window.location.href.split("code=");
    ar = ar[1].split("&");
    var code = ar[0];

    // id を取得 ---
    let id_token = window.location.href.split("id_token=");
    id_token = id_token[1].split("&");
    id_token = parseJwt(id_token[0]);
    document.cookie = "niconico_id=" + id_token.sub + "; path=/; domain:127.0.0.1; max-age=259200; secure; samesite=lax;";

    // state 取得 --- ここから
    ar = window.location.href.split("state=");
    var state = ar[1];
    // state=hoge#foo 対応
    if(state.match(/#/)) {
      ar = state.split("#");
      state = ar[0];
    }
    // state 取得 --- ここまで

    var rj;
    var oauth_site_name;

    PG_oauth_verify(code,shop_permanent_domain,state);

  } else if (window.location.href.match(openid_complete) && (shop_permanent_domain != "ticket-sun-a.myshopify.com" &&  shop_permanent_domain != "sanei-demo-store.myshopify.com")) {
    PG_sms_fcid_token_login(window.location.href.split("token=")[1]);
  } else if (window.location.href.match(error)){
    var error_status = window.location.href.split("error_status=")[1];
    if (error_status === '429') {
      PG_idcon_show_error_use_scss("<div>ただいまアクセスが集中しています。</div>  <div>しばらく時間をおいてから再度お試しください。</div>");
    } else {
      PG_idcon_show_error_use_scss("<div>システムエラーが発生しました。</div>  <div>しばらく時間をおいてから再度お試しください</div>");
    }
  //////////////////////////////////////////////////////////////////////////////
  // tokenがあった場合
  //////////////////////////////////////////////////////////////////////////////
  } else if(window.location.href.match(r2str) && (shop_permanent_domain == "ticket-sun-a.myshopify.com" || shop_permanent_domain == "sanei-demo-store.myshopify.com")) {
    console.log("do PG_companyS_verify");
    // code 取得 ---
    var ar = window.location.href.split("token=");
    ar = ar[1].split("&");
    var token = ar[0];

    PG_companyS_verify(token);

  //////////////////////////////////////////////////////////////////////////////
  // codeがなかった場合 (最初のログインステップ)
  //////////////////////////////////////////////////////////////////////////////
  } else {
    // 画面を表示する ---
    $('body').css('visibility','visible');

      // ID連携必要かどうかチェック ---
      if(false == false) {
        if(shop_permanent_domain == "ticket-sun-a.myshopify.com" || shop_permanent_domain == "sanei-demo-store.myshopify.com") {
          $("#PG_div_idcon_Another").css("display","flex");
          $("#PG_div_idcon_Another").css("flex-direction","column");
          let redirect_to = "";
          if(shop_permanent_domain == "ticket-sun-a.myshopify.com") {
            redirect_to = "https://ticket.san-ei-corp.co.jp/account/login?token={token}";
          } else if(shop_permanent_domain == "sanei-demo-store.myshopify.com") {
            redirect_to = "https://sanei-demo-store.myshopify.com/account/login?token={token}";
          }
          $("#PG_div_idcon_Another").html("<a href='https://id.san-ei-corp.co.jp/users/login?dept_code=ticket.sun-a&redirect=" + redirect_to + "'><img src='//iwatevc-official-store.moala.live/cdn/shop/t/3/assets/pg-companyS-login-top_img.png?v=179538367598340344501792749685' style='margin: 50px auto 0px auto; padding-left: 0px; padding-right: 0px;' border='0'></a><div style='margin: 20px auto 0px auto;'>チケットの購入にはログインが必要です。<br>会員登録がまだお済みでない方は次のページより新規登録へお進みください。</div><a href='https://id.san-ei-corp.co.jp/users/login?dept_code=ticket.sun-a&redirect=" + redirect_to + "'><img src='//iwatevc-official-store.moala.live/cdn/shop/t/3/assets/pg-companyS-login-btn.png?v=14919918741736223141792749683' style='margin: 30px auto 0px auto;' border='0'></a>");
        } else {
          $("#PG_div_idcon_WithOut").css("display","block");
        }
        return;
      }
    // NOTE: ローカルでshopifyからのID連携なら、realmはngrok ドメインを設定してください
    // fetch("https://[domain].ngrok.io/api/v1/oauth_sites?myshopify_domain=" + shop_permanent_domain)
    fetch("https://shopify.engineer.quickticket.moala.fun/api/v1/oauth_sites?myshopify_domain=" + shop_permanent_domain)
    .then(function(response) {
      if (response.ok) {
        return response.text();
      } else {
        if(response.status == 429) {
          PG_idcon_show_error("<div style='font-weight: 800; text-align: left;'>ただいまアクセスが集中しています。</div>  <div style='text-align: left;'>しばらく時間をおいてから再度お試しください。</div>");
          throw Error();
        } else {
          return response.json().then(function(err) {
            PG_idcon_show_error("");
            throw Error(err.type);
          });
        }
      }
    }).then(function(strj) {
      rj = JSON.parse(strj);
      ar_q = [];

      if(rj.oauth_sites.length == 0) {
        $("#PG_div_idcon_WithOut").css("display","block");
      } else {
        if(rj.oauth_sites[0].name === 'sms_fanclub') {
          $("#pg_idcon_area").html(
            "<p> <div style='display: inline-block; width: 100%; text-align: center;'><img src='" + rj.oauth_sites[0].image_url + "' border='0' style='width: 270px;'></div> <a href='" + "https://shopify.engineer.quickticket.moala.fun/api/v1/oauth_sites/discovery?myshopify_domain=" + shop_permanent_domain + "'><div style=\"margin-top: 38px; padding: 16px 16px 16px 16px; border-radius: 32px; background-color: #1B1B1B; color: #FFFFFF; font-family: 'Work Sans','Helvetica Neue','ヒラギノ角ゴ ProN W3',Hiragino Kaku Gothic ProN,Arial,'メイリオ',Meiryo,sans-serif; font-size: 16px; font-weight: 600; \">" + "XXXX へ ログイン" + "</div></a>" + "XXXX".replace('_AUTHURL_', rj.oauth_sites[0].url)
          );
        } else {
          // params を追加する ---
          for(key in rj.oauth_sites[0].params) {
            v = rj.oauth_sites[0].params[key];
            if(v instanceof Array) {
              v = v.join("%20");
            }
            ar_q.push(key + "=" + v);
          }

          // nonce を追加する ---
          ar_q.push("nonce" + "=" + rj.nonce);

          // state を追加する ---
          ar_q.push("state" + "=" + rj.oauth_sites[0].name);

          // redirect_uri を追加する ---
          ar_q.push("redirect_uri" + "=" + encodeURIComponent(document.baseURI.split('?')[0]));

          str_q = ar_q.join("&");

          $("#pg_idcon_area").html(
            "<p> <div style='display: inline-block; width: 100%; text-align: center;'><img src='" + rj.oauth_sites[0].image_url + "' border='0' style='width: 270px;'></div> <a href='" + rj.oauth_sites[0].url + "?" + str_q + "'><div style=\"margin-top: 38px; padding: 16px 16px 16px 16px; border-radius: 32px; background-color: #1B1B1B; color: #FFFFFF; font-family: 'Work Sans','Helvetica Neue','ヒラギノ角ゴ ProN W3',Hiragino Kaku Gothic ProN,Arial,'メイリオ',Meiryo,sans-serif; font-size: 16px; font-weight: 600; \">" + "XXXX へ ログイン" + "</div></a>" + "XXXX".replace('_AUTHURL_', rj.oauth_sites[0].url + "?" + str_q)
          );
        }
      }
    }).catch(function(err) {
    });
  }
}

// =============================================================================
//  ID連携用 ステップ /oauth/verify
// =============================================================================
function PG_oauth_verify(code,shop_permanent_domain,oauth_site_name) {

  var headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  // エラーテスト用 ---
  // shop_permanent_domain = "xxx.myshopify.com";
  // oauth_site_name = "hogehoge";

  // redirect_uri 作成 ---
  redirect_uri = document.baseURI;
  ar = redirect_uri.split("?");
  redirect_uri = ar[0];

  var body = {
    code: code,
    myshopify_domain: shop_permanent_domain,
    oauth_site_name: oauth_site_name,
    redirect_uri: redirect_uri
  };
  body = JSON.stringify(body);

  fetch("https://shopify.engineer.quickticket.moala.fun/api/v1/oauth/verify",
    {
      method: 'POST',
      headers: headers,
      body: body
    }
  ).then(function(response) {
    if (response.ok) {
      return response.text();
    } else {
      if(response.status == 429) {
          PG_idcon_show_error("<div style='font-weight: 800; text-align: left;'>ただいまアクセスが集中しています。</div>  <div style='text-align: left;'>しばらく時間をおいてから再度お試しください。</div>");
          throw Error();
      } else {
        return response.json().then(function(err) {
          if(err.code == "invalid_id_token") {
            PG_idcon_show_error("最初からログインをして下さい");
          } else {
            PG_idcon_show_error("<div style='font-weight: 800; text-align: left;'>システムエラーが発生しました。</div>  <div style='text-align: left;'>しばらく時間をおいてから再度お試しください</div>");
          }
          throw Error(err);
        });
      }
    }
  }).then(function(strj) {
    rj = JSON.parse(strj);

    document.forms.customer_login.elements.CustomerEmail.value = rj.email;
    document.forms.customer_login.elements.CustomerPassword.value = rj.password;
    document.forms.customer_login.submit();

  }).catch(function(err) {
  });

}

// =============================================================================
//  FCID連携用 token_login
// =============================================================================
function PG_sms_fcid_token_login(token) {
  fetch("https://shopify.engineer.quickticket.moala.fun/api/v1/shopify_users/token_login?token=" + token)
  .then(function(response) {
    if (response.ok) {
      return response.text();
    } else {
      if(response.status == 429) {
          PG_idcon_show_error_use_scss("<div>ただいまアクセスが集中しています。</div>  <div>しばらく時間をおいてから再度お試しください。</div>");
          throw Error();
      } else {
        return response.json().then(function(err) {
          if(err.code == "invalid_token") {
            PG_idcon_show_error("最初からログインをして下さい");
          } else {
            PG_idcon_show_error_use_scss("<div>システムエラーが発生しました。</div>  <div>しばらく時間をおいてから再度お試しください</div>");
          }
          throw Error(err);
        });
      }
    }
  }).then(function(strj) {
    rj = JSON.parse(strj);
    document.forms.customer_login.elements.CustomerEmail.value = rj.email;
    document.forms.customer_login.elements.CustomerPassword.value = rj.password;
    document.forms.customer_login.submit();
  }).catch(function(err) {
  });
}

// =============================================================================
//  S社 ID連携用 ステップ verify
// =============================================================================
function PG_companyS_verify(token) {

  fetch(PG_companyS_idcon_verify_api_path + "?token=" + token,
    {
      method: 'GET'
    }
  ).then(function(response) {
    if (response.ok) {
      return response.text();
    } else {
      response.text().then(function (msg) {
        console.log(msg);
      });
      // id-connect-error に飛ばす
      location.href = "/pages/id-connect-error";
    }
  }).then(function(strj) {
    rj = JSON.parse(strj);
    document.forms.PG_customer_login.elements.PG_CustomerEmail.value = rj.email;
    document.forms.PG_customer_login.elements.PG_CustomerPassword.value = rj.password;
    document.forms.PG_customer_login.submit();
  }).catch(function(err) {
  });
}

// =============================================================================
//  ID連携用 メールアドレスを送信するボタン制御
// =============================================================================
function PG_idcon_control_btn_VerifyEmail_color() {
  if($("#VerifyEmail").val() == "") {
    $("#PG_btn_VerifyEmail").css("background-color","#7A7A7A");
    $("#PG_btn_VerifyEmail").off();
  } else {
    $("#PG_btn_VerifyEmail").css("background-color","#295FCC");
    $("#PG_btn_VerifyEmail").off();
    $("#PG_btn_VerifyEmail").on("click",PG_idcon_codes);
  }
}

// =============================================================================
//  K社 ID連携用 ステップ verify
// =============================================================================
function PG_companyK_verify(api_path, uid, signature, timestamp, store_code, env_code) {

  fetch(api_path + "verify?uid=" + uid + "&signature=" + encodeURIComponent(signature) + "&timestamp=" + timestamp + "&store_code=" + store_code + "&env_code=" + env_code,
    {
      method: 'GET'
    }
  ).then(function(response) {
    if (response.ok) {
      return response.text();
    } else {
      console.log(response.status);
      response.text().then(function (msg) {
        console.log(msg);
      });
      gigya.accounts.logout();
    }
  }).then(function(strj) {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if(urlParams.has('nexturl')) {
      const nexturl = PG_FilterNextURL(urlParams.get('nexturl'));
      if(nexturl == null) {
        gigya.accounts.logout();
        return;
      }
      gigya.accounts.getJWT({
        callback: function(response) {
          if (response.errorCode === 0) {
            document.forms.PG_member_enquete.action = nexturl;
            document.forms.PG_member_enquete.elements.id_token.value = response.id_token;
            document.forms.PG_member_enquete.submit();
          } else {
            gigya.accounts.logout();
          }
        },
      });
      return;
    } else if(!(localStorage.getItem('enquete_url') == null || localStorage.getItem('enquete_url') == "")) {
      if(localStorage.getItem('login_count') == '1') {
        if(urlParams.has('redirecturl')) {
          localStorage.setItem('referrer', PG_FilterRedirectURL(urlParams.get('redirecturl')));
        }
        document.forms.PG_customer_login.elements.PG_CustomerCheckoutURL.value = localStorage.getItem('enquete_url');
      } else if(localStorage.getItem('login_count') == '2') {
        if(urlParams.has('redirecturl')) {
          localStorage.setItem('external_url', PG_FilterRedirectURL(urlParams.get('redirecturl')));
        } else {
          let ele_return_to = document.createElement("input");
          ele_return_to.type = "hidden";
          ele_return_to.id = "return_to";
          ele_return_to.name = "return_to";
          ele_return_to.value = "/";
          document.forms.PG_customer_login.appendChild(ele_return_to);
        }
      }
      localStorage.removeItem('enquete_url');
    } else if(urlParams.has('redirecturl')) {
      localStorage.setItem('external_url', PG_FilterRedirectURL(urlParams.get('redirecturl')));
    } else if(urlParams.has('return_url')) {
      const return_url = encodeURI(urlParams.get('return_url'));
      document.forms.PG_customer_login.elements.PG_CustomerCheckoutURL.value = return_url;
    } else if(urlParams.has('checkout_url')) {
      const checkout_url = encodeURI(urlParams.get('checkout_url'));
      document.forms.PG_customer_login.elements.PG_CustomerCheckoutURL.value = checkout_url;
    } else {
      if(localStorage.getItem('goto_checkout') != '1') {
        document.forms.PG_customer_login.elements.PG_CustomerCheckoutURL.value = '/';
      }
    }

    rj = JSON.parse(strj);
    document.forms.PG_customer_login.elements.PG_CustomerEmail.value = rj.email;
    document.forms.PG_customer_login.elements.PG_CustomerPassword.value = rj.password;
    document.forms.PG_customer_login.submit();

  }).catch(function(err) {
  });
}

// =============================================================================
//  K社 ID連携用 ステップ unsubscribe
// =============================================================================
function PG_companyK_unsubscribe(api_path, uid, signature, timestamp, store_code, env_code) {

  fetch(api_path + "unsubscribe?uid=" + uid + "&signature=" + encodeURIComponent(signature) + "&timestamp=" + timestamp + "&store_code=" + store_code + "&env_code=" + env_code,
    {
      method: 'GET'
    }
  ).then(function(response) {
    if (response.ok) {
      return response.text();
    } else {
      if(response.status == 422) {
        response.text().then(function (strj) {
          rj = JSON.parse(strj);
          console.log(rj.err_msg);
        });
        location.href = "/pages/id-connect-error";
      }
    }
  }).then(function(strj) {
    rj = JSON.parse(strj);
    console.log(rj);
    gigya.accounts.logout();
  }).catch(function(err) {
  });
}

// =============================================================================
//  ID連携用 メールアドレスを送信するボタン 押した時に呼ぶ関数
// =============================================================================
function PG_idcon_codes() {

  var headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  var body = {
    customer_id: PG_idcon_customer_id,
    email: $("#VerifyEmail").val()
  };
  body = JSON.stringify(body);

  fetch("https://shopify.engineer.quickticket.moala.fun/api/v1/codes",
    {
      method: 'POST',
      headers: headers,
      body: body
    }
  ).then(function(response) {
    if (response.ok) {
      return response.text();
    } else {
      if(response.status == 429) {
          PG_idcon_show_error("<div style='font-weight: 800; text-align: left;'>ただいまアクセスが集中しています。</div>  <div style='text-align: left;'>しばらく時間をおいてから再度お試しください。</div>");
          throw Error();
      } else {
        return response.json().then(function(err) {
          if(err.code == "invalid_email") {
            PG_idcon_show_error_2("PG_VerifyEmail_error","既に登録されているメールアドレスです。別のメールアドレスで認証してください。");
          } else {
            PG_idcon_show_error_2("PG_VerifyEmail_error","エラーがおきました (" + err.type + ")");
          }
          throw Error(err);
        });
      }
    }
  }).then(function(strj) {
    PG_idcon_wait();
  }).catch(function(err) {
  });
}

// =============================================================================
//  ID連携用 メールアドレスを送信するボタン 押した後、一定時間　ボタンを押せなくする
// =============================================================================
var PG_idcon_wait_c = 0;
var PG_idcon_wait_cmax = 60;  // (何秒間押せなくするかの設定値)
function PG_idcon_wait() {
  PG_idcon_wait_c++;
  if(PG_idcon_wait_c >= PG_idcon_wait_cmax) {
    PG_idcon_wait_c = 0;
    $("#PG_btn_VerifyEmail").css("background-color","#295FCC");
    $("#VerifyEmail").prop('disabled', false);
    $("#PG_btn_VerifyEmail").html("メールアドレスを送信する");
    $("#PG_btn_VerifyEmail").off();
    $("#PG_btn_VerifyEmail").on("click",PG_idcon_codes);
  } else {
    $("#PG_btn_VerifyEmail").css("background-color","#7A7A7A");
    $("#VerifyEmail").prop('disabled', true);
    var disp_c = PG_idcon_wait_cmax - PG_idcon_wait_c;
    $("#PG_btn_VerifyEmail").html(disp_c);
    $("#PG_btn_VerifyEmail").off();
    setTimeout(PG_idcon_wait,1000);
  }
}

// =============================================================================
//  ID連携用 コードを送信するボタン制御
// =============================================================================
function PG_idcon_control_btn_VerifyCode_color() {
  if($("#VerifyCode").val() == "") {
    $("#PG_btn_VerifyCode").css("background-color","#7A7A7A");
    $("#PG_btn_VerifyCode").off();
  } else {
    $("#PG_btn_VerifyCode").css("background-color","#295FCC");
    $("#PG_btn_VerifyCode").off();
    $("#PG_btn_VerifyCode").on("click",PG_idcon_verify_email);
  }
}

// =============================================================================
//  ID連携用 コードを送信するボタン 押した時に呼ぶ関数
// =============================================================================
function PG_idcon_verify_email() {

  // リクエスト中、ボタンを非活性にする ---
  $("#PG_btn_VerifyCode").css("background-color","#7A7A7A");
  $("#PG_btn_VerifyCode").off();

  var headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  var body = {
    customer_id: PG_idcon_customer_id,
    code: $("#VerifyCode").val()
  };
  body = JSON.stringify(body);

  fetch("https://shopify.engineer.quickticket.moala.fun/api/v1/shopify_users/verify_email",
    {
      method: 'POST',
      headers: headers,
      body: body
    }
  ).then(function(response) {
    if (response.ok) {
      return response.text();
    } else {
      if(response.status == 429) {
          PG_idcon_show_error("<div style='font-weight: 800; text-align: left;'>ただいまアクセスが集中しています。</div>  <div style='text-align: left;'>しばらく時間をおいてから再度お試しください。</div>");
          throw Error();
      } else {
        return response.json().then(function(err) {
          if(err.type == "invalid_code") {
            PG_idcon_show_error_2("PG_VerifyCode_error","有効期限が切れているか、コードが違います");
          } else {
            PG_idcon_show_error_2("PG_VerifyCode_error","エラーがおきました (" + err.type + ")");
          }

          // 再度、入力できるようにボタンを活性化する ---
          $("#PG_btn_VerifyCode").css("background-color","#295FCC");
          $("#PG_btn_VerifyCode").off();
          $("#PG_btn_VerifyCode").on("click",PG_idcon_verify_email);

          throw Error(err);
        });
      }
    }
  }).then(function(strj) {

    rj = JSON.parse(strj);
    $("#PG_idcon_authsite_image").html("<div style='display: inline-block; width: 100%; text-align: center;'><img src='" + rj.oauth_sites[0].image_url + "' border='0' style='width: 270px;'></div>");

    $("#PG_idcon_verify_section").css("display","none");
    $("#PG_idcon_verify_success_section").css("display","block");
    window.scrollTo(0,0);
    setTimeout(PG_idon_refresh,3000);
  }).catch(function(err) {
  });

}

// =============================================================================
//  ID連携用 ランクを更新するボタン制御
// =============================================================================
function PG_update_rank() {

  // 処理中であることのユーザーへのフィードバック
  $("body").css("opacity","0.3");

  // 連打防止のため、一時的に onclick 属性を削除。
  $("#pg_update_rank_btn").removeAttr("onclick");

  var headers = {
    "Accept": "application/json",
    "Content-Type": "application/json"
  };

  var body = {
    customer_id: PG_idcon_customer_id
  };

  fetch("https://shopify.engineer.quickticket.moala.fun/api/v1/shopify_users",
    {
      method: "PATCH",
      headers: headers,
      body: JSON.stringify(body)
    }
  ).then(function(response) {
    if(response.ok) {
        location.reload();
    } else {
      $("#pg_update_rank_btn_error").html("<div style='margin-top: 24px;'>エラーが発生しました。</div><div>しばらくしてからもう一度お試しください。</div>");
    }
  }).catch(function() {
  }).finally(function() {
    // 処理が終わってから 3秒後に onclick 属性を付与。
    setTimeout(function() {
      $("#pg_update_rank_btn").attr("onclick", "PG_update_rank()");
    }, 3000);
    $("body").css("opacity","");
  });
}

// =============================================================================
//  ID連携用 認証完了後にマイページをリフレッシュする
// =============================================================================
function PG_idon_refresh() {
  location.reload();
}

// =============================================================================
//  ID連携用 エラー文字列表示
// =============================================================================
function PG_idcon_show_error(errmsg) {
  if(errmsg == "") {
    errmsg = "エラーがおきました";
  }

  $("body").css("visibility","visible");

  $("#pg_idcon_area").html(
    "<div style=\"margin-top: 32px; padding: 16px 16px 16px 16px; background-color: #FCF5F5; border: 1px #E68A8A solid; font-family: 'Work Sans','Helvetica Neue','ヒラギノ角ゴ ProN W3',Hiragino Kaku Gothic ProN,Arial,'メイリオ',Meiryo,sans-serif; font-size: 16px; font-weight: 400; color: #CC2929; \">" + errmsg + "</div>"
  );
}

// =============================================================================
//  ID連携用 エラー文字列表示(style をscss ファイルに置いた)
// =============================================================================
function PG_idcon_show_error_use_scss(error_message) {
  if(error_message == "") {
    error_message = "エラーがおきました";
  }
  $("body").css("visibility","visible");
  $("#pg_idcon_area").html(
    "<div id='error_message_area' class='error-message-text'>" + error_message + "</div>"
  );
}

// =============================================================================
//  ID連携用 エラー文字列表示 ver 2
// =============================================================================
function PG_idcon_show_error_2(div_id,errmsg) {
  if(errmsg == "") {
    errmsg = "エラーがおきました";
  }

  $("#" + div_id).html(
    "<div style=\"margin-top: 12px; margin-left: 24px; padding: 8px 8px 8px 8px; background-color: #FCF5F5; border: 1px #E68A8A solid; font-family: 'Work Sans','Helvetica Neue','ヒラギノ角ゴ ProN W3',Hiragino Kaku Gothic ProN,Arial,'メイリオ',Meiryo,sans-serif; font-size: 12px; font-weight: 400; color: #CC2929; \">" + errmsg + "</div>"
  );
}

// =============================================================================
//  PG 購入ボタン
// =============================================================================
function PG_product_purchase() {

  // グッズの場合で、選んでいるオプションの在庫が切れていた場合 ---
  if($('[id^="pg_option"]').length) {

    let str_op = PG_goods_create_str_op();

    if(PG_goods_can_buy_check(str_op) == false) {
      return;
    }
  }

  // 同意する機能が設置されている 且つ チェックが付いていない場合 ---
  if(($("#PG_agree_before_buy").length > 0) && $("#PG_agree_before_buy").prop("checked") == false) {
    let cart_msg_div = $('[id^="pg_msg_add_to_cart_"]');
    let cart_msg = "同意する場合は、チェックボックスにチェックを入れてください";
    for(let i = 0; i < cart_msg_div.length; i++) {
      $("#" + cart_msg_div[i].id).html(cart_msg);
    }
    return false;
  }

  // シリアルコード購入制限の場合 ---
  if(typeof PG_use_purchase_with_serialcode !== 'undefined' && PG_use_purchase_with_serialcode) {
    if(!PG_dynamic_checkout_onprocess) {
      PG_purchase_with_serialcode_dynamic_checkout();
    }
    return;
  }

  let rs = $('[id^="pg_variant"]');
  let item = [];
  let info = {};

  for(let i = 0; i < rs.length; i++) {

    let ar = rs[i].id.split("pg_variant_");
    let sid = ar[1];

    info["quantity"] = parseInt($("#" + rs[i].id).val());
    info["id"] = parseInt(sid);

    if(info["quantity"] == 0) {
      continue;
    }

    let itm = {
      id : info["id"],
      quantity : info["quantity"]
    };

    // サブスクの場合、selling_plan を追加する ---
    if(JSON.parse("false".toLowerCase()) && $('[name^="planOption"]').length) {
      let selling_plan = $('[name^="selling_plan"]')[0].value;
      if(selling_plan != "") {
        itm.selling_plan = parseInt(selling_plan);
      } else {
        let cart_msg_div = $('[id^="pg_msg_add_to_cart_"]');
        let cart_msg = "";
        cart_msg = "プランを指定してください";
        for(let i = 0; i < cart_msg_div.length; i++) {
          $("#" + cart_msg_div[i].id).html(cart_msg);
        }
        return false;
      }
    }


    item.push(itm);

  }

  if(item.length == 0) {
    let cart_msg_div = $('[id^="pg_msg_add_to_cart_"]');
    let cart_msg = "";
    if(PG_product_purchase_ptype == "primary" || PG_product_purchase_ptype == "secondary" || PG_product_purchase_ptype == "goods" || PG_product_purchase_ptype == "primary_live_streaming" || PG_product_purchase_ptype == "primary_streaming") {
      cart_msg = "枚数を指定してください";
    } else if(PG_product_purchase_ptype == "goods") {
      cart_msg = "数量を指定してください";
    } else if(PG_product_purchase_ptype == "subscription") {
      cart_msg = "数量を指定してください";
    } else {
      cart_msg = "数量を指定してください";
    }
    for(let i = 0; i < cart_msg_div.length; i++) {
      $("#" + cart_msg_div[i].id).html(cart_msg);
    }
    return false;
  }

  if (document.querySelector('.direct-checkout-btn')) {
    // 商品グループ購入制限機能を使っている場合、カートを経由せずダイレクトでチェックアウトページに飛ぶ。
    goToDirectCheckout();
  } else {
    let json = {items:item};

    jQuery.post(
      '/cart/add.js',
      json
    ).always(
      function() {
        location.href = "/cart";
      }
    );
  };
}

// =============================================================================
//  PG カートを経由せず直接チェックアウトページに遷移
// =============================================================================
const goToDirectCheckout = async () =>  {
  const getRequestToken = () => {
    const shopifyFeatureScript = document.querySelector("script[id='shopify-features']");
    const shopifyFeatureJson = JSON.parse(shopifyFeatureScript.innerHTML);
    const token = btoa(shopifyFeatureJson.accessToken);
    return token;
  };

  const getLineItems = () => {
    let variantItEle = "";
    let opt_ids = document.querySelectorAll('input[id^="pg_variant_"]');
    if(opt_ids.length > 0) {
      let tmp_vid = document.querySelectorAll('input[id^="pg_variant_"][value="1"]');
      variantItEle = tmp_vid[0].id.replace("pg_variant_","");
    } else {
      variantItEle = document.querySelector('#ProductSelect-product-template > option');
    }
    const variantId = Number(variantItEle);
    const variantEle = document.querySelector(`#pg_variant_${variantId}`);
    const quantity =  Number(variantEle.value);

    if(PG_product_purchase_ptype == "subscription") {
      const shopifyScript = document.querySelector("script[id='ProductJson-product-template']");
      const shopifyJson = JSON.parse(shopifyScript.innerHTML);
      const data = shopifyJson.variants
      if(data[0]["selling_plan_allocations"][0] != null){
        return [{ variant_id: variantId, quantity: quantity, selling_plan_id: data[0]["selling_plan_allocations"][0]["selling_plan_id"]}];
      }
    }
    return [{ variant_id: variantId, quantity: quantity}];
  };

  const lineItems = getLineItems();

  if (lineItems.length > 0) {
    const cartPath = lineItems
      .map(item => `${item.variant_id}:${item.quantity}`)
      .join(',');

    let checkoutUrl = `/cart/${cartPath}`;location.href = checkoutUrl;
  }
};

// =============================================================================
//  PG 通常カート用：カートからログインへ移動
// =============================================================================
function PG_cart_to_login_for_default() {
  localStorage.setItem('goto_checkout', '1');
  location.href = "/account/login";
}

// =============================================================================
//  PG カートからログインへ移動し、ログイン後にカートに戻る
// =============================================================================
function PG_cart_to_login() {
  localStorage.setItem('goto_cart', '1');
  location.href = "/account/login";
}

// =============================================================================
//  PG 独自チェックアウト用：カートからログインへ移動
// =============================================================================
function PG_cart_to_login_for_other_checkout() {
  localStorage.setItem('goto_checkout', '0');
  location.href = "/account/login";
}

// =============================================================================
//  PG カートからログインへ移動
// =============================================================================
function PG_cart_to_VerifyEmail() {
  location.href = "/account";
}

// =============================================================================
//  PG グッズ 商品詳細 オプションを変えた時のアクション
// =============================================================================
function PG_goods_change_option() {

  let str_op = PG_goods_create_str_op();

  // 値段部分更新 ---
  $("#PG_goods_price_info").html(PG_goods_generate_goods_price_info(str_op));

  let add_to_cart_btn = $('[id^="pg_btn_wrapper_"]');

  let agree_div = document.querySelector("div.custom-style-pg-btn-add-to-cart-agree-checkbox-div");

  // 在庫判定処理 ---
  if(PG_goods_can_buy_check(str_op)) {

    $("#PG_goods_stock_info").html("在庫あり");

    // 在庫があって、同意チェックボックスがあった場合 ---
    if(agree_div) {

      if(typeof PG_purchase_with_srialcode_mode == "undefined") {
        agree_div.style.display = "flex";
      } else {
        if(PG_purchase_with_srialcode_mode == 1) {
        } else if(PG_purchase_with_srialcode_mode == 2) {
           agree_div.style.display = "flex";
        }
      }

      if($("#PG_agree_before_buy").prop("checked")) {
        for(let i = 0; i < add_to_cart_btn.length; i++) {
          $("#" + add_to_cart_btn[i].id).removeClass("custom-style-pg-btn-add-to-cart-btn-before-agree");
          $("#" + add_to_cart_btn[i].id).removeClass("custom-style-pg-btn-add-to-cart-btn-available");
          $("#" + add_to_cart_btn[i].id).removeClass("custom-style-pg-btn-add-to-cart-btn-not-available");
          $("#" + add_to_cart_btn[i].id).addClass("custom-style-pg-btn-add-to-cart-btn-after-agree");
          document.getElementById(add_to_cart_btn[i].id).querySelector("div").innerHTML = PG_str_purchase;
        }
      } else {
        for(let i = 0; i < add_to_cart_btn.length; i++) {
          $("#" + add_to_cart_btn[i].id).removeClass("custom-style-pg-btn-add-to-cart-btn-available");
          $("#" + add_to_cart_btn[i].id).removeClass("custom-style-pg-btn-add-to-cart-btn-not-available");
          $("#" + add_to_cart_btn[i].id).addClass("custom-style-pg-btn-add-to-cart-btn-before-agree");
          document.getElementById(add_to_cart_btn[i].id).querySelector("div").innerHTML = PG_str_purchase;
        }
      }
    // 在庫があって、同意チェックボックスがなかった場合 ---
    } else {
      for(let i = 0; i < add_to_cart_btn.length; i++) {
        $("#" + add_to_cart_btn[i].id).removeClass("custom-style-pg-btn-add-to-cart-btn-not-available");
        $("#" + add_to_cart_btn[i].id).addClass("custom-style-pg-btn-add-to-cart-btn-available");
        document.getElementById(add_to_cart_btn[i].id).querySelector("div").innerHTML = PG_str_purchase;
      }
    }

  } else {

    $("#PG_goods_stock_info").html("在庫なし");

    // 在庫がなくて、同意チェックボックスがあった場合 ---
    if(agree_div) {
      document.querySelector("div.custom-style-pg-btn-add-to-cart-agree-checkbox-div").style.display = "none";

      let cart_msg_div = $('[id^="pg_msg_add_to_cart_"]');
      for(let i = 0; i < cart_msg_div.length; i++) {
        $("#" + cart_msg_div[i].id).html("");
      }
    }

    for(let i = 0; i < add_to_cart_btn.length; i++) {
      $("#" + add_to_cart_btn[i].id).addClass("custom-style-pg-btn-add-to-cart-btn-not-available");
      $("#" + add_to_cart_btn[i].id).removeClass("custom-style-pg-btn-add-to-cart-btn-available");
      $("#" + add_to_cart_btn[i].id).removeClass("custom-style-pg-btn-add-to-cart-btn-before-agree");
      $("#" + add_to_cart_btn[i].id).removeClass("custom-style-pg-btn-add-to-cart-btn-after-agree");
      document.getElementById(add_to_cart_btn[i].id).querySelector("div").innerHTML = "販売終了";
    }

  }

  PG_goods_change_amount();
}

// =============================================================================
//  PG グッズ 商品詳細 数量を変えた時のアクション
// =============================================================================
function PG_goods_change_amount() {

  let rs = $('[id^="pg_variant"]');

  for(let i = 0; i < rs.length; i++) {
    $("#" + rs[i].id).val("0");
  }

  let str_op = PG_goods_create_str_op();

  $("#pg_variant_" + PG_p_vid[str_op]).val($("#pg_amount").val());

}

// =============================================================================
//  PG グッズ 商品詳細 在庫数や在庫切れでも販売を続けるを含めた購入可否判定
// =============================================================================
function PG_goods_can_buy_check(str_op) {

  let canbuy_flg = true;

  // variant の available が true の場合 ---
  if(PG_p_available[str_op]) {

    // 選択した数量が、在庫数よりも多い場合 ---
    if(PG_p_inventory_quantity[str_op] < parseInt($("#pg_amount").val())) {

      // 「在庫切れの場合でも販売を続ける」がチェックされている場合は 買える
      if(PG_p_inventory_policy[str_op] == "continue") {
        canbuy_flg = true;
      // 「在庫切れの場合でも販売を続ける」がチェックされていない場合は 買えない
      } else {
        canbuy_flg = false;
      }

    // 選択した数量が、在庫数に満たしてない場合 ---
    } else {

      // 買えない
      canbuy_flg = true;

    }

  // variant の available が false の場合 ---
  } else {

    // 買えない
    canbuy_flg = false;

  }

  return canbuy_flg;

}

// =============================================================================
//  PG グッズ 商品詳細 str_op 文字列作成
// =============================================================================
function PG_goods_create_str_op() {

  let rs = $('[id^="pg_option"]');
  let str_op = "";

  for(let i = 0; i < rs.length; i++) {
    str_op = str_op + $("#" + rs[i].id).val();
  }

  return str_op;

}

// =============================================================================
//  PG グッズ 商品詳細 商品価格情報 を生成する
// =============================================================================
function PG_goods_generate_goods_price_info(str_op) {

  var price = PG_p_price[str_op] / 100;
  price = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');

  if(PG_p_compare_at_price[str_op] == null) {
    return "¥" + price + PG_display_tax_info;
  } else {
    var price_compare_at_price = PG_p_compare_at_price[str_op] / 100;
    price_compare_at_price = String(price_compare_at_price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    return "<div class=\"custom-style-product-template-compare-at-price-first-div\"><div class=\"custom-style-product-template-compare-at-price-second-div\">¥" + price_compare_at_price + "</div></div>" + "¥" + price + PG_display_tax_info;
  }

}

// =============================================================================
//  PG 商品詳細ページ 購入条件の会員へ登録する リンクを押した時
// =============================================================================
function PG_goto_site(url, product_id) {
  localStorage.setItem('last_url', location.href);
  localStorage.setItem('should_update_rank', 'true');

  // NOTE: subパラメーターにproduct_idを追加する
  if (product_id != null) {
    var sub_str = "sub=" + product_id;
    location.href = url.replace("sub=", sub_str);
  } else {
    location.href = url;
  }
}

// =============================================================================
//  PG ログイン後、localStorageに last_url があったら、その URL へリダイレクトする
// =============================================================================
function PG_check_last_url() {
  var last_url = localStorage.getItem('last_url');

  if(last_url == null) {
    return;
  }

  if(last_url != "") {
    $(".page-width").css("visibility","hidden");
    localStorage.removeItem('last_url');
    location.href = last_url;
  }
}

// =============================================================================
//  PG ログイン後、localStorageに goto_checkout があったら、その checkout へリダイレクトする
// =============================================================================
function PG_check_goto_checkout(myshopify_domain, customer_email, customer_name, checkout_page_url) {

  var goto_checkout = localStorage.getItem('goto_checkout');

  if(goto_checkout == null) {
    return;
  }

  $('body').css("visibility","hidden");
  localStorage.removeItem('goto_checkout');

  if(goto_checkout == "0") {
    redirect_to_checkout(myshopify_domain, customer_email, customer_name, checkout_page_url);
  } else if(goto_checkout == "1") {
    location.href = '/checkout';
  }
}

// =============================================================================
//  PG fetch が使えるか 使えないか判定
// =============================================================================
function PG_no_fetch() {

  if(window.fetch == undefined) {

      // 画面を表示する ---
      $('body').css('visibility','visible');
      PG_idcon_show_error("<div style='color: #1B1B1B; text-align: left;'>お使いの端末またはOSバージョンは、動作環境ではありません。</div> <div style='color: #1B1B1B; text-align: left;'>推奨環境・動作環境については<a href='' style='color: #CC2929; border-bottom: 1px #CC2929 solid; '>こちら</a>をご確認ください。</div>");

    return true;

  } else {

    return false;

  }
}

// =============================================================================
//  PG カートで数字を変えた時にその商品の買える数の最大数を制御する
// =============================================================================
function PG_cart_check_max(o) {
  if(parseInt(o.value) > o.max) {
    o.value = o.max;
  }
}

// =============================================================================
//  PG 注文詳細画面で返金するボタンを押した時の処理
// =============================================================================
function PG_start_refund() {
  var input = document.getElementById("PG_refund_name");
  input.classList.remove("input--error");
  $("#PG_refund_error_message").css("display", "none");
  $(".dissmiss_for_refund").css("display", "none");
  $("#PG_refund_form").css("display", "block");
}

// =============================================================================
// PG JS 返金入力フォームで確認画面へ進むボタンを押した時の処理
// =============================================================================
function PG_confirm_refund() {
  var name = document.getElementById('PG_refund_name').value;
  $("#PG_refund_form").css("display", "none");
  $("#PG_refund_confirmation").css("display", "block");
  $("#PG_refund_name_confirmation").text(name);
  window.scrollTo(0, 110);
}
// =============================================================================
// PG JS 返金確認画面で返金申し込みボタンを押した時の処理
// =============================================================================
function PG_apply_refund(order_id) {
  $("#PG_refund_apply_btn").prop("disabled", true);

  var headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  var body = {
    "order_id": Number(order_id),
    "account_name": document.getElementById('PG_refund_name').value,
    "myshopify_domain": ""
  };
  console.log(document.getElementById('PG_refund_name').value);
  body = JSON.stringify(body);

  fetch("-" + "-",
    {
      method: 'POST',
      headers: headers,
      body: body
    }
  ).then(function(response) {
    if (response.ok) {
      return response.text();
    } else {
      if(response.status == 422) {
        return response.json().then(function(err) {
          if(err.type == "user_information") {
            throw Error(err.message);
          } else {
            throw Error('Shopify Api Error');
          }
        });
      } else if (response.status == 409) {
        return response.json().then(function(err) {
          if (err.type = "parameter") {
            throw Error('既に払い戻し済です。');
          }
        });
      } else {
        return response.json().then(function(err) {
          throw Error('Internal Server Error');
        });
      }
    }
  }).then(function(strj) {
    $("#PG_refund_confirmation").css("display", "none");
    $(".dissmiss_for_refund").css("display", "block");
    $("#PG_btn_start_refund").css("display", "none");
    $("#PG_refund_thx_msg").css("display", "block");
    window.location.reload();
  }).catch(function(err) {
    console.log(err.message);
    if (err.message == 'Internal Server Error' || err.message == 'Shopify Api Error') {
      $("#PG_refund_confirmation").css("display", "none");
      $("#PG_refund_area").html("<div style=\"margin-top: 32px; padding: 16px 16px 16px 16px; background-color: #FCF5F5; border: 1px #E68A8A solid; font-family: 'Work Sans','Helvetica Neue','ヒラギノ角ゴ ProN W3',Hiragino Kaku Gothic ProN,Arial,'メイリオ',Meiryo,sans-serif; font-size: 16px; font-weight: 400; color: #CC2929; \">" + "しばらく時間をおいてから再度お試しください" + "</div>");
      setTimeout(function() {
        window.location.reload();
      }, 3000);
    } else {
      $("#PG_refund_confirmation").css("display", "none");
      $("#PG_refund_form").css("display", "block");
      $("#PG_refund_error_message").css("display", "block");
      var mem = err.message.split(/。/)[0] + "。";
      if (mem != "") {
        if (err.message.split(/。/).length == 1) {
          var message = err.message;
        } else {
          var oem = err.message.split(/。/)[1].replace(/ /, "");
          if (oem != "") {
            var soem = "" + oem.split("");
            var message = mem + '<br>' + '<span style="font-weight: 600;">' + `"${soem}"` + '</span>';
          } else {
            var message = err.message;
          }
        }
      } else {
        var message = mem + '<br>' + '<span style="font-weight: 600;">' + `"${err.message}"` + '</span>';
      }
      $("#PG_refund_apply_btn").prop("disabled", false);
      $("#PG_refund_error_text").html(message);
      $("#PG_refund_name").val('');
      $("#PG_refund_error_jump").get(0).scrollIntoView(true);
    }
  });
}

// =============================================================================
// PG JS 返金フォームで戻るボタンを押した時の処理
// =============================================================================
function PG_stop_refund() {
  location.href = location.href;
}

// =============================================================================
// PG JS 返金申込みキャンセル画面へ遷移する
// =============================================================================
function PG_cancel_refund_start() {
  $(".dissmiss_for_refund").css("display", "none");
  $("#PG_apply_refund_cancel_start").css("display", "block");
}

// =============================================================================
// PG JS 返金申込みキャンセル画面から注文詳細へ戻る
// =============================================================================
function PG_cancel_refund_stop() {
  $("#PG_apply_refund_cancel_start").css("display", "none");
  $("#PG_apply_refund_cancel_content").css("display", "block");
  $(".dissmiss_for_refund").css("display", "block");
}

// =============================================================================
// PG JS 返金申込みキャンセルを実行する
// =============================================================================

function PG_cancel_refund_apply(order_id) {
  $("#PG_apply_refund_cancel").prop("disabled", true);

  var headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  fetch("-" + "-" + String(order_id),
    {
      method: 'DELETE',
      headers: headers,
    }
  ).then(function(response) {
    if (response.ok) {
      return response.text();
    } else {
      return response.json().then(function(err){
        throw Error(err.message);
      });
    }
  }).then(function(strj) {
    var input = document.getElementById("PG_refund_name");
    input.classList.remove("input--error");
    $("#PG_apply_refund_cancel_start").css("display", "none");
    $("#PG_refund_error_message").css("display", "none");
    $(".dissmiss_for_refund").css("display", "none");
    $("#PG_refund_form").css("display", "block");
    $("#PG_refund_error_jump").get(0).scrollIntoView(true);
  }).catch(function(err) {
    if (err.message == "already deposited" || err.message == "already processed") {
      $("#PG_apply_refund_cancel_start").css("display", "none");
      $("#PG_show_already_deposited").css("display", "block");
      $("#PG_apply_refund_cancel").prop("disabled", false);
    } else {
      console.log(err.message);
      $(".cancel_refund_error_message").css("display, block");
      $("#PG_apply_refund_cancel_start").css("display", "none");
      $("#PG_refund_area").html("<div style=\"margin-top: 32px; padding: 16px 16px 16px 16px; background-color: #FCF5F5; border: 1px #E68A8A solid; font-family: 'Work Sans','Helvetica Neue','ヒラギノ角ゴ ProN W3',Hiragino Kaku Gothic ProN,Arial,'メイリオ',Meiryo,sans-serif; font-size: 16px; font-weight: 400; color: #CC2929; \">" + "しばらく時間をおいてから再度お試しください" + "</div>");
      setTimeout(function() {
        window.location.reload();
      }, 3000);
    }
  });
}

// =============================================================================
// PG JS 「既に入金済みです」画面から注文詳細に戻るためのボタン
// =============================================================================
function PG_close_refund_cancel_page() {
  $("#PG_show_already_deposited").css("display", "none");
  $(".dissmiss_for_refund").css("display", "block");
}

// =============================================================================
// PG 最終確認画面でのキャンセルボタン
// =============================================================================
function PG_cancel_confirmation() {
  $("#PG_refund_confirmation").css("display", "none");
  $("#PG_refund_form").css("display", "block");
  var name = document.getElementById("PG_refund_name").value;
  $("#PG_refund_name_confirmation").text(name)
}
// =============================================================================
// PG クリップボードにシリアルコードをコピーする
// =============================================================================
function PG_copy_serial_number(str) {
  var ta = document.createElement("input");
  ta.value = str;
  document.body.appendChild(ta);
  ta.select();
  document.execCommand("copy");
  ta.parentElement.removeChild(ta);

  // PG TOAST START -------
  var o = document.createElement('div');
  o.style.backgroundColor = "rgba(27, 27, 27, 0.6)";
  o.style.color = "#FFFFFF";
  o.style.width = "271px";
  o.innerText = "コピーしました";
  o.id = "toast";
  document.body.appendChild(o);
  $("#toast").css("position", "fixed");
  $("#toast").css("text-align", "center");
  $("#toast").css("padding-top", "16px");
  $("#toast").css("padding-bottom", "16px");
  $("#toast").css("font-size", "16px");
  $("#toast").css("border-radius", "4px");
  $("#toast").css("left", Number((window.innerWidth / 2) - parseInt($("#toast").css("width")) / 2) + "px");
  if (window.innerWidth >= 750) {
    $("#toast").css("bottom", "450px");
  } else {
    $("#toast").css("bottom", "350px");
  }
  setTimeout(PG_hide_toast, 2000);
  // PG TOAST END ---------
}

// =============================================================================
// PG トーストを削除する
// =============================================================================
function PG_hide_toast() {
  $("#toast").fadeOut("slow", function() {
    $("#toast").remove();
  });
}

// =============================================================================
// 古いライブコマース、いずれ削除する
// =============================================================================
function PG_display_target_item(product_id) {
  var i = 0;
  var strhtml = "";
  if(PG_lcg[product_id] != undefined) {
    while(PG_lcg[product_id][i] != undefined) {
      strhtml = strhtml + PG_lcg[product_id][i];
      i++;
    }
    if(strhtml != "") {
      $("#live_commerce_ul").html(strhtml);
    }
  }
}

// =============================================================================
// PG ブログのタグを押した時のアクション
// =============================================================================
function PG_blog_jump2tag(blog_url,tag_key,tag_data) {
  console.log(tag_key,tag_data);
  localStorage.setItem('show_blog_by_tag', tag_key + ":" + tag_data);
  location.href = blog_url;
}

// =============================================================================
// PG マイページのinfoアイコンを押したときの挙動
// =============================================================================
function PG_show_info() {
  var ele = document.getElementById("pg_baloon");
  if (ele.className == 'balloon-close') {
    ele.className = 'balloon-open';
  } else {
    ele.className = "balloon-close";
  }
}

// =============================================================================
// PG 購入判定用：カートからログイン後にカートへ戻る
// =============================================================================
function PG_check_goto_cart() {
  var go_cart_flag = localStorage.getItem('goto_cart');

  // go_cart_flag === "1"の場合、ログイン画面認証後、カート画面へ戻る
  if (go_cart_flag === "1") {
    $('body').css("visibility","hidden");
    localStorage.removeItem('goto_cart');
    location.href = '/cart';
  }
}
// =============================================================================
// PG 独自チェックアウト画面へのリンク挙動
// =============================================================================
async function redirect_to_checkout (myshopify_domain, customer_email, customer_name, checkout_page_url) {
  var cart_obj = await fetch_cart_items();
  var cart_items = cart_obj.items;
  var line_items = [];
  for (var i = 0; i < cart_items.length; i++) {
    if (!cart_items[i].product_id) {
      continue;
    }

    var obj = {
      "variant_id": cart_items[i].variant_id,
      "quantity": cart_items[i].quantity,
      "product_id": cart_items[i].product_id
    };

    line_items.push(obj);
  }
  var data = {
    "shopify": {
      "store_domain": myshopify_domain,
      "order": {
        "email": customer_email,
        "name": customer_name,
        "line_items": line_items
      }
    }
  };
  var form = document.createElement('form');
  form.innerHTML = '<input name="params" hidden>';
  form.action = checkout_page_url;
  form.method = 'POST';
  form.params.value = JSON.stringify(data);
  document.body.append(form);
  form.submit();
  return true;
}

function fetch_cart_items() {
  var result = fetch('/cart.js').then(function (response) {
    if (response.status == 200) {
      return response.json();
    } else {
      return response.json().then(function(err){
        throw Error(err.message);
      });
    }
  }).then(function (data) {
    return data;
  }).catch(function () {
    return 'Error';
  });
  if (result != 'Error') {
    return result;
  }
}

// =============================================================================
// PG クエリストリングの取得
// =============================================================================
function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

// =============================================================================
// PG A社のログインURL取得
// =============================================================================
function PG_companyA_getUrl(api_path) {
  fetch(
    api_path + "/geturl",
    {
      method: 'GET'
    }
  ).then(function(response) {
    if (response.ok) {
      return response.text();
    } else {
      if(response.status == 422) {
        response.text().then(function (strj) {
          rj = JSON.parse(strj);
        });
        location.href = "/pages/id-connect-error";
      }
    }
  }).then(function(strj) {
    rj = JSON.parse(strj);
    state = rj['url'].split("state=");
    localStorage.setItem('state', state[1]);
    location.href = rj['url'];
  }).catch(function(err) {
  });
}

function hideIconText() {
  const element = document.getElementById('PG_menu_icon');
  const iconTextElement = document.getElementById('PG_menu_icon_text');
  const initialMargin = iconTextElement.style.marginTop;
  const initialHeight = iconTextElement.style.height;
  let isDisplay = true;
  element.addEventListener('click', () => {
    isDisplay = !isDisplay;
    if (isDisplay) {
      iconTextElement.style.visibility = 'visible';
      iconTextElement.style.marginTop = initialMargin;
      iconTextElement.style.height = initialHeight;
    } else {
      iconTextElement.style.visibility = 'hidden';
      iconTextElement.style.height = '0';
      iconTextElement.style.marginTop = '0';
    }
  });
}

// =============================================================================
// PG OIDC の id_token から payload を取得
// =============================================================================
function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(atob(base64)
    .split('')
    .map(function (c) {
      return '%' + ('00' + c.charCodeAt(0)
          .toString(16))
        .slice(-2);
    })
    .join(''));
  return JSON.parse(jsonPayload);
};

// =============================================================================
// PG HTML をエスケープしてただの文字列情報として出力
// =============================================================================
const escapeHTML = (str) => {
  return str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
};

function PG_BuildAllowedOrigins(urls) {

  let origins = [];

  (urls || []).forEach(function(value) {
    if(typeof value !== 'string' || value.trim() == "") {
      return;
    }
    try {
      let parsed = new URL(value.trim());
      if(parsed.protocol === 'https:' && origins.indexOf(parsed.origin) < 0) {
        origins.push(parsed.origin);
      }
    } catch (e) {
    }
  });

  return origins;

}

function PG_FilterNextURL(url) {

  if(typeof url !== 'string' || url == "") {
    return null;
  }

  let parsed;
  try {
    parsed = new URL(url);
  } catch (e) {
    return null;
  }

  if(parsed.protocol !== 'https:') {
    return null;
  }

  let allowed = window.PG_NEXTURL_ALLOWED_ORIGINS;
  if(!Array.isArray(allowed) || allowed.indexOf(parsed.origin) < 0) {
    return null;
  }

  return parsed.href;

}

// =============================================================================
// PG redirecturl をフィルタリングする
// =============================================================================
function PG_FilterRedirectURL(url) {

  if(typeof PG_SafeRedirectURL !== 'function') {
    return "/";
  }

  return PG_SafeRedirectURL(url) || "/";
}

// =============================================================================
// PG 購入済ロジック挿入
// =============================================================================
function PG_pp_bought_Logic(el_array) {
  let PG_my_pids = Customer.boughtProductIDs();
  let this_is_what_i_bought = false;

  for(let i = 0; i < el_array.length; i++) {
    this_is_what_i_bought = false;
    for(let j = 0; j < PG_my_pids.length; j++) {
      if(PG_my_pids[j] == el_array[i].attributes.pid.value) {
        this_is_what_i_bought = true;
        break;
      }
    }
    if(this_is_what_i_bought) {
      let bought_div = document.createElement("div");
      let insert_a = el_array[i].querySelector("a");
      let insert_parent = insert_a.parentNode;

      bought_div.innerHTML = "<div class='custom-style-product-pickup-by-date-bought-text-div'>購入済</div>";
      bought_div.className = "custom-style-product-pickup-by-date-bought-div";
      bought_div.setAttribute("onclick","location.href = '" + insert_a.href + "'");

      insert_parent.insertBefore(bought_div, insert_a);

    }
  }

};

// =============================================================================
// PG 購入済レイアウト修正
// =============================================================================
function PG_pp_bought_Logic_fix_layout() {
  let bought_div = document.querySelectorAll(".custom-style-product-pickup-by-date-bought-div");
  for(let i = 0; i < bought_div.length; i++) {
    let parentNode = bought_div[i].parentNode;
    bought_div[i].style.height = parentNode.scrollHeight + "px";
  }
}

// =============================================================================
// PG 見逃し視聴終了時間 & 販売終了時間 表示　ロジック挿入
// =============================================================================
function PG_pp_display_EndTime_Logic(el_array) {

  let w = [ "日", "月", "火", "水", "木", "金", "土" ];

  for(let i = 0; i < el_array.length; i++) {
    for(let j = 0; j < PG_p.length; j++) {
      if(PG_p[j].pid == el_array[i].attributes.pid.value) {
        let description_div = el_array[i].querySelector(".custom-style-product-card-grid-product-description");

        let re = /!--\/\/ B/;
        let res = PG_p[j].description.match(re);

        if(res) {

        } else {

          let str_stet = "";
          let str_saet = "";

          if(PG_p[j].stet != "") {
            let pg_stet_now = new Date(PG_p[j].stet);
            if(PG_p[j].tags.indexOf('fbv:yes') == -1) {
              if(PG_p[j].type == "primary_streaming") {
                str_stet = "※視聴は ";
              } else {
                str_stet = "※見逃し配信期間は ";
              }
              str_stet = str_stet + (pg_stet_now.getMonth() + 1) + "/" + pg_stet_now.getDate() + " (" + w[pg_stet_now.getDay()] + ") " + pg_stet_now.getHours() + ":" + PG_zeroPadding(pg_stet_now.getMinutes(),2) + "まで";
            } else {
              str_stet = "※各公演の見逃し配信期間は詳細をご確認ください";
            }
          }

          if(PG_p[j].saet != "") {
            let pg_saet_now = new Date(PG_p[j].saet);
            str_saet = "※販売は " + (pg_saet_now.getMonth() + 1) + "/" + pg_saet_now.getDate() + " (" + w[pg_saet_now.getDay()] + ") " + pg_saet_now.getHours() + ":" + PG_zeroPadding(pg_saet_now.getMinutes(),2) + "まで";
          }

          description_div.innerHTML = str_saet + "<BR>" + str_stet;
        }


      }
    }
  }

}

// =============================================================================
// PG 0で埋める
// =============================================================================
function PG_zeroPadding(num,length){
    return ('0000000000' + num).slice(-length);
}

// =============================================================================
// PG ◆配信日時 を表示する
// =============================================================================
function PG_yts_display_BroadCastTime(mode,div_id,lsst,lset,stet,saet,type,tags,stst) {

  let w = [ "日", "月", "火", "水", "木", "金", "土" ];

  let pg_lsst_now = new Date(lsst);
  let pg_lset_now = new Date(lset);
  let pg_stet_now = new Date(stet);
  let pg_saet_now = new Date(saet);

  let str = "";

  function convert_to_JST(date, isOnlyTime) {
    const new_date = new Date(date);
    const time_zone_full_options = { weekday: 'short', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', timeZone: 'Asia/Tokyo' };
    const time_zone_onlyTime_options = { hour: 'numeric', minute: 'numeric', timeZone: 'Asia/Tokyo' };
    let JST_date = '';

    (isOnlyTime)? JST_date = new_date.toLocaleString('ja-JP', time_zone_onlyTime_options) : JST_date = new_date.toLocaleString('ja-JP', time_zone_full_options)
    JST_date = JST_date.replace(/\(/g, '（').replace(/\)/g, '）').replace(/ /g, '');
    return JST_date;
  }

  if (tags.indexOf('fbv:yes') == -1) {

    str = `◆配信スケジュール<BR>`;
    const str_default = str;

    if(type != "primary_streaming") {
      if(lsst != "1970-01-01T00:00:00Z" && lsst != "") {
        str = str + convert_to_JST(lsst, false).replace('）', '）配信開始');
      }

      if(lset != "1970-01-01T00:00:00Z" && lset != "") {
        str = str + `　配信終了予定` + convert_to_JST(lset, true) + `<BR>`
      } else {
        if(lsst != "1970-01-01T00:00:00Z" && lsst != "") {
          str = str + `<BR>`
        }
      }
    }

    if(saet != "1970-01-01T00:00:00Z" && saet != "") {
      str = str + `※販売は` + convert_to_JST(saet, false) + `まで` + `<BR>`;
    }

    if(stet != "1970-01-01T00:00:00Z" && stet != "") {
      if(type == "primary_streaming") {
        str = str + `※視聴は`;
      } else {
        str = str + `※見逃し配信期間は`;
      }
      str = str + convert_to_JST(stet, false) + `まで` + `<BR>` + `<BR>`;
    }

    if(stet != "1970-01-01T00:00:00Z" && stet != "" && stst == "") {
      if(type == "primary_streaming" || tags.includes('fixedtext:no')) {
      } else {
        str = str + `※この公演はFANY IDの会員ステータスに関係なく見逃し配信期間内であれば視聴をお楽しみいただけます。尚、見逃し配信はライブ配信終了後より始まります。ライブ配信終了から見逃し配信に切り替わるまでお時間をいただく可能性がございます。見逃し配信期間については、配信スケジュールをご確認ください。` + `<BR>` + `<BR>`;
      }
    }

    if(stst != "1970-01-01T00:00:00Z" && stst != "") {
      str = str + `上記見逃し配信期間中、視聴開始ボタンを押してから最大で以下の期間視聴可能です。` + `<BR>`;
      str = str + `FANY IDメンバーは最大24時間` + `<BR>`;
      str = str + `FANY IDプレミアムメンバーは最大72時間視聴可能です。` + `<BR>`;
      str = str + `<BR>`;
      str = str + `例：見逃し配信期間が11/7　23:59までのとき` + `<BR>`;
      str = str + `①11/3　11:00に見逃し視聴を開始した場合` + `<BR>`;
      str = str + `FANYIDメンバー　　　　　　11/4　11：00まで` + `<BR>`;
      str = str + `FANYIDプレミアムメンバー　11/6　11：00まで` + `<BR>`;
      str = str + `<BR>`;
      str = str + `②11/6　11:00に見逃し視聴を開始した場合` + `<BR>`;
      str = str + `FANYIDメンバー　　　　　　11/7　11：00まで` + `<BR>`;
      str = str + `FANYIDプレミアムメンバー　11/7　23：59まで` + `<BR>`;
      str = str + `<BR>`;
      str = str + `※配信終了予定時刻を過ぎますとライブ配信の視聴ができない場合がございます。予めご了承ください。` + `<BR>`;
      str = str + `※配信終了予定時刻の2時間後から、見逃し視聴の開始が可能です。` + `<BR>`;
      str = str + `※公演の見逃し配信終了日時を過ぎての視聴はできません。余裕を持ってご視聴をお楽しみください。` + `<BR>`;
      str = str + `※配信期間が延長となった際、すでに見逃し視聴を開始・終了してる場合は視聴期限の変更や延長はございません。` + `<BR>`;
    }

    if(str == str_default) {
      str = "";
    }

  }

  if(mode == 1) {
    $("#" + div_id).html(str);
  } else if(mode == 2) {
    return str;
  }

}

// =============================================================================
// PG 記事検索時に表示されるh2タグを消す
// =============================================================================
function PG_remove_search_h2_title(type) {
  const search_card_elements = document.querySelector("." + type + "-card." + type + "-card--list");
  if(!search_card_elements){
    document.querySelector("." + type + "-search-h2-title").remove();
  }
}

function PG_header_account_click(url) {
  localStorage.setItem("header_account_click", true);
  location.href = url;
}


// =============================================================================
// TD の場合は td logout を実施する
// =============================================================================
function PG_td_logout() {
  console.log("yobaretayo")
  tdIdLinkage.logout();
}